import {StandingsWidgetFilterViewModel} from "./standings-widget.filter.view-model";

export class StandingsWidgetFilterTableTypesViewModel extends StandingsWidgetFilterViewModel {
  get type(): Number {
    return this.entity.type;
  }

  get name(): String {
    return this.entity.name;
  }
}
